import React from 'react';
import { useSelector } from 'react-redux';
import { Alert, Button } from '@mui/material';

export default function CartCatalogStatus() {
  const { catalogStatus, items } = useSelector(state => state.cartSlice);
  if (!items.length) return null;
  if (catalogStatus === 'loading') return <p role="status">Uppdaterar produkter, priser och lager…</p>;
  if (catalogStatus === 'error') return <Alert severity="warning" action={<Button onClick={() => window.dispatchEvent(new Event('dolcehem:refresh-cart'))}>Försök igen</Button>}>Aktuella produktuppgifter kunde inte bekräftas. Varukorgen finns kvar.</Alert>;
  if (items.some(item => item.unavailable)) return <Alert severity="warning">En produkt kan inte längre beställas eller saknar tillräckligt lager. Minska antalet eller ta bort produkten i varukorgen.</Alert>;
  return null;
}
